import type { Phrase } from './copy.js';

/**
 * The in-match route, the room's chrome, and the shell every other screen
 * wears. The room's own words — the wait, the pot, the seats, the connection —
 * already live in `copy.room.ts`; this fragment only adds what those files say
 * on top of them.
 */
export const TABLE = {
  /* ── The bar above the table ──────────────────────────────────────────── */
  /** A miron is not seated, so there is nothing to walk away from. */
  'table.stop': { tl: 'Tigil', en: 'Stop' },
  'table.kubo': { tl: 'Kubo {code}', en: 'Room {code}' },
  /** The pill's amount is bold, so the label is its own word. */
  'table.pot': { tl: 'Pot', en: 'Pot' },

  /* ── Where in the compound, and for how much ──────────────────────────── */
  'venue.dama.station': { tl: 'Ang bangketa', en: 'The sidewalk' },
  'venue.tongits.station': { tl: 'Bangko sa tindahan', en: 'The store bench' },
  'venue.pusoydos.station': { tl: 'Ang garahe', en: 'The garage' },
  'venue.mahjong.station': { tl: 'Ang karport', en: 'The carport' },
  'venue.pusoy.station': { tl: 'Ang balkonahe', en: 'The balcony' },
  'venue.gera.station': { tl: 'Outpost ng barangay', en: 'The village outpost' },
  'stake.barya': { tl: 'Barya', en: 'Small stakes' },
  'stake.bente': { tl: 'Bente', en: 'Mid stakes' },
  'stake.datu': { tl: 'Datu', en: 'High stakes' },

  /** Fills the venue slot when the route has a match but no venue to name. */
  'table.thisgame': { tl: 'larong ito', en: 'this game' },

  /* ── The screen shell ─────────────────────────────────────────────────── */
  'table.back': { tl: 'Balik', en: 'Back' },
  'table.store': { tl: 'Tindahan', en: 'Store' },
  'table.settings': { tl: 'Settings', en: 'Settings' },
  'table.settings.label': {
    tl: 'Settings at responsableng laro',
    en: 'Settings and responsible play',
  },
  /*
   * The venue titles, in the dictionary rather than in the protocol's VENUES
   * data so that each one is a single line to change.
   *
   * All six read the same in both languages. Four of them do have English
   * names players elsewhere use — Dama is checkers, Pusoy Dos is Big Two,
   * Pusoy is Chinese poker, Gera is war — and they are deliberately not used:
   * these are the names of the tables in this compound, and a player who came
   * for Pusoy Dos did not come for Big Two. Tongits has no English name at
   * all, and Mahjong already is one.
   */
  'venue.dama': { tl: 'Dama', en: 'Dama' },
  'venue.tongits': { tl: 'Tongits', en: 'Tongits' },
  'venue.pusoydos': { tl: 'Pusoy Dos', en: 'Pusoy Dos' },
  'venue.mahjong': { tl: 'Mahjong', en: 'Mahjong' },
  'venue.pusoy': { tl: 'Pusoy', en: 'Pusoy' },
  'venue.gera': { tl: 'Gera', en: 'Gera' },
} as const satisfies Record<string, Phrase>;
